module.exports = __webpack_public_path__ + "static/media/index.8d106fa1.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Accessibility/index.md
// module id = 188
// module chunks = 0